// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import vueHeadful from 'vue-headful';
import components from './components/index'
import VueFuse from 'vue-fuse'
import VueStringFilter from 'vue-string-filter'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import VueAnalytics from 'vue-analytics'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import filters from './filters'
import VueClipboard from 'vue-clipboard2'
import VueWaypoint from 'vue-waypoint'
import VuePictureSwipe from 'vue-picture-swipe';
import VueGtag from "vue-gtag";

Vue.use(VueAnalytics, {
  id: 'UA-5998602-6',
  router
})

Vue.use(VueGtag, {
  config: { id: "G-5YC1DHELE1" },
  includes: [
    { 
      id: 'AW-10996102901',
      params: {
        send_page_view: false
      }
    }
  ]
});

Vue.use(VueClipboard)
Vue.use(vueNumeralFilterInstaller, {locale: 'en-AU'});
Vue.use(VueStringFilter)
Vue.use(VueFuse)
Vue.use(VueAxios, axios)
Vue.use(VueWaypoint)
Vue.use(require('vue-moment'));
Vue.component('vue-headful', vueHeadful);
Vue.component(VueQrcode.name, VueQrcode);
Vue.component('vue-picture-swipe', VuePictureSwipe);


Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

Object.keys(components).forEach((key) => {
  Vue.component(`v-${key}`, components[key])
})

Vue.config.productionTip = false

Vue.prototype.domainURL = window.location.host;

Vue.prototype.apiURL = function() {
  return process.env.NODE_ENV === 'development' 
    ? 'https://api.daojia.com.au' 
    : 'https://api.daojia.com.au';
}

Vue.prototype.theURL = function () {
  return 'https://www.daojia.com.au';
}

Vue.prototype.depositAmount = function () {
  return 50;
}

Vue.prototype.ifHoliday = function (){
  return false;
}

Vue.prototype.holidayWord = function (){
  return '圣诞元旦节日期间无法提供上门服务';
}

Vue.prototype.sleep = function (time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

Vue.prototype.DisabledDateRangesMove = function () {
  return [
    { // 禁止12月25-26日
      from: new Date(2025, 11, 25),
      to: new Date(2025, 11, 27)
    },
    { // 禁止12月31日-1月1日
      from: new Date(2025, 11, 31),
      to: new Date(2026, 0, 2)
    }
  ];
}

Vue.prototype.DisabledDateRangesClean = function () {
  return [
    { // 禁止12月24日-1月1日（共9天）
      from: new Date(2025, 11, 24),
      to: new Date(2026, 0, 2)
    }
  ];
}

// 获取日期选择器应该默认打开的月份
// 优先使用已选日期，避免重新渲染后月份被重置
Vue.prototype.getOpenDate = function (selectedDate) {
  if (selectedDate) {
    let parsedDate = new Date(selectedDate);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate;
    }
  }

  let today = new Date();
  let tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  if (today.getMonth() !== tomorrow.getMonth()) {
    return tomorrow;
  }
  return today;
}

Vue.prototype.userCatch = function (type,name,phone,iflast=false){
  this.axios.post(this.apiURL()+'/Globals/orderWaive',
    qs.stringify(
      {
        type_id:type,
        member_name:name,
        member_phone:phone,
        progress_final:iflast
      }
    )
  )
  .then(function (response) {
    console.log(response.data.data);
  })
  .catch(function (error) {
  });
}

Vue.prototype.pixelURL = function (type, step) {
  let phone = "";
  if (localStorage.member_phone) {
    phone = localStorage.member_phone;
  }
  else if (this.hasOwnProperty('order')) {
    if (this.order.hasOwnProperty('data')){
      if (this.order.data.move_out_phone) {
        phone = this.order.data.move_out_phone;
      } else if (this.order.data.address_phone) {
        phone = this.order.data.address_phone;
      }
    }

  }
  return "https://log.daojia.com.au/pixel.log?phone=" + phone + "&type=" + type + "&step=" + step
}

Vue.prototype.orderUpdate = function (item,newData,url){
    //函数用于动态设置data中的属性和值
    this.order.data[item] = newData;

    //设置后将data的值以string形式存入localStorage
    localStorage.order = JSON.stringify(this.order);

    if(localStorage.isEditing&&url){
      let checkoutUrl = localStorage.isEditing;
      this.$router.push(checkoutUrl);
      localStorage.isEditing = '';
    }
    //如果带网址参数，在更新完data后立即进行跳转
    else if(url){
      this.$router.push(url);
    }
}

Vue.prototype.orderSkipEditAndUpdate = function (item,newData,url){
    //函数用于动态设置data中的属性和值
    this.order.data[item] = newData;

    //设置后将data的值以string形式存入localStorage
    localStorage.order = JSON.stringify(this.order);

    if(url){
      this.$router.push(url);
    }
}

Vue.prototype.orderSkipEditAndUpdateAll = function (url) {
  localStorage.order = JSON.stringify(this.order);
  if(url){
    this.$router.push(url);
  }
}

Vue.prototype.orderUpdateAll = function (url){
  localStorage.order = JSON.stringify(this.order);

  if(localStorage.isEditing){
    let checkoutUrl = localStorage.isEditing;
    localStorage.isEditing = '';
    this.$router.push(checkoutUrl);
  }

  else if(url){
    this.$router.push(url);
  }
}

Vue.prototype.goto = function (url){
  if(localStorage.isEditing){
    let checkoutUrl = localStorage.isEditing;
    localStorage.isEditing = '';
    this.$router.push(checkoutUrl);
  }
  else{
    this.$router.push(url);
  }
}

Vue.prototype.dataUpdate = function (name,value){
  this.name = value;
}


Vue.prototype.checkLogin = function (){
  if (localStorage.hasOwnProperty('token') && localStorage.token) {
    return true;
  }
  else{
    return false;
  }
}

Vue.prototype.clearLoginLS = function (){
  localStorage.removeItem('token');
  localStorage.removeItem('member_phone');
  localStorage.removeItem('member_email');
  localStorage.removeItem('member_name');
  localStorage.removeItem('tokenExpire');
  localStorage.removeItem('order');
  localStorage.removeItem('savedMove');
  localStorage.removeItem('savedClean');
}

Vue.prototype.profileValidate = function (){
  if(localStorage.hasOwnProperty('token')){
    this.axios.post(this.apiURL()+'/User/userInfo',
      qs.stringify(
        {
          token: localStorage.token
        }
      )
    )
    .then(function (response) {
      if(response.data.error_code!=0){
        this.clearLoginLS();
        this.$router.push('/login');
      }
      else{
        localStorage.member_phone = response.data.data.phone;
        localStorage.member_email = response.data.data.email;
        localStorage.member_name = response.data.data.name;
      }
    })
    .catch(function (error) {
    });
  }
}

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

global.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js